import moment from 'moment'

import { ApiError } from 'api/adcritterApi'
import { AudienceFootprint, BudgetFrequency, CampaignApprovalDelivery } from 'api/interfaces'
import { formatCurrency } from 'utils/Formatters'

export const formatApprovalBudget = (budget: number, budgetFrequency: BudgetFrequency): string => `${formatCurrency(budget)} ${budgetFrequency.toLowerCase()}`

export const formatApprovalDate = (date: moment.Moment | null): string => (date ? moment(date).format('MM/DD/yyyy') : 'None')

export const formatApprovalDateRange = (startDate: moment.Moment | null, endDate: moment.Moment | null): string => `${formatApprovalDate(startDate)} - ${formatApprovalDate(endDate)}`

export const formatFootprintSummary = (audienceFootprint: AudienceFootprint | null): string => (audienceFootprint && audienceFootprint.states.length > 0 ? audienceFootprint.states.join(', ') : 'None')

interface ApprovalErrorData {
  errors?: ApiError[]
}

export const extractApprovalErrorMessage = (error: unknown, fallback: string): string => {
  if (error && typeof error === 'object' && 'data' in error) {
    const data = (error as { data?: ApprovalErrorData }).data
    const message = data?.errors?.[0]?.message
    if (message) {
      return message
    }
  }
  return fallback
}

const defaultDelivery: CampaignApprovalDelivery = { targetWeb: true, targetApp: false, targetPc: true, targetPhone: true, targetTablet: true }

const resolveDelivery = (delivery?: CampaignApprovalDelivery): CampaignApprovalDelivery => delivery ?? defaultDelivery

export const formatDeliveryFrequency = (delivery?: CampaignApprovalDelivery): string => {
  const frequency = resolveDelivery(delivery).frequency
  return frequency ? `${frequency} views / user` : 'No frequency cap'
}

export const formatDeliveryTargetCpm = (delivery?: CampaignApprovalDelivery): string => {
  const targetCpm = resolveDelivery(delivery).targetCpm
  return targetCpm ? `${formatCurrency(targetCpm)} CPM` : 'Auto CPM'
}

const joinEnabled = (options: Array<[string, boolean]>): string => {
  const enabled = options.filter(([, isEnabled]) => isEnabled).map(([label]) => label)
  return enabled.length > 0 ? enabled.join(', ') : 'None'
}

export const formatDeliveryInventory = (delivery?: CampaignApprovalDelivery): string => {
  const resolved = resolveDelivery(delivery)
  return joinEnabled([
    ['App', resolved.targetApp],
    ['Web', resolved.targetWeb]
  ])
}

export const formatDeliveryDevices = (delivery?: CampaignApprovalDelivery): string => {
  const resolved = resolveDelivery(delivery)
  return joinEnabled([
    ['PC', resolved.targetPc],
    ['Phone', resolved.targetPhone],
    ['Tablet', resolved.targetTablet]
  ])
}
